module.exports = __webpack_public_path__ + "static/top-right-bc123b553511db9397201010944e38fc.png";